import { Navigate, useLocation } from 'react-router-dom';
import { loadStorage } from '../../Utils/Utils';

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const token = loadStorage('token');
    if (!token) {
        return <Navigate to="/" state={{ openLogin: true, from: location.pathname }} replace />;
    }
    return children;
};

export default PrivateRoute;
